import type { MessagingGetChatRoomById200LastMessageBasicInfo } from './messagingGetChatRoomById200LastMessageBasicInfo';
import type { MessagingGetChatRoomById200LastMessageSender } from './messagingGetChatRoomById200LastMessageSender';
import type { MessagingGetChatRoomById200LastMessageStatus } from './messagingGetChatRoomById200LastMessageStatus';

/**
 * 마지막 메시지
 */
export type MessagingGetChatRoomById200LastMessage = {
  basicInfo?: MessagingGetChatRoomById200LastMessageBasicInfo;
  /** 발신자 정보 */
  sender?: MessagingGetChatRoomById200LastMessageSender;
  /** 메시지 상태 정보 */
  status?: MessagingGetChatRoomById200LastMessageStatus;
};
